import { useNavigate } from "react-router-dom";
import { Eye, PhoneCall } from "lucide-react";
import { CoinIcon } from "@/components/Icons";

export default function LiveCard({ stream }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid={`live-card-${stream.id}`}
      onClick={() => navigate(`/stream/${stream.id}`)}
      role="button"
      className="relative rounded-3xl overflow-hidden aspect-[3/4] w-full text-left group active:scale-[0.98] transition-transform cursor-pointer bg-[#1E1830]"
    >
      <img src={stream.thumbnail} alt={stream.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/5 to-black/30" />
      <div className="absolute top-2.5 left-2.5 flex items-center gap-1.5">
        <span className="pulse-live bg-[#FF3B5C] text-white text-[10px] font-extrabold px-2 py-0.5 rounded-full tracking-wide">LIVE</span>
        <span className="bg-black/45 backdrop-blur-md text-[10px] font-semibold px-2 py-0.5 rounded-full flex items-center gap-1 text-white">
          <Eye size={10} /> {stream.viewers?.toLocaleString()}
        </span>
      </div>
      <span className="absolute top-2.5 right-2.5 bg-black/45 backdrop-blur-md text-[9px] font-semibold px-2 py-0.5 rounded-full text-white/80">{stream.category}</span>
      <div className="absolute bottom-0 left-0 right-0 p-3">
        {stream.host?.calls_enabled && (
          <button
            data-testid={`call-now-badge-${stream.id}`}
            onClick={(e) => { e.stopPropagation(); navigate(`/profile/${stream.host.id}`); }}
            className="ml-auto mb-1.5 bg-[#00E0C7]/15 backdrop-blur-md border border-[#00E0C7]/50 text-[#00E0C7] text-[10px] font-bold px-2.5 py-1 rounded-full flex items-center gap-1 w-fit active:scale-95 transition-transform"
          >
            <PhoneCall size={9} /> Call <CoinIcon size={10} />{stream.host.call_rate_video}/min
          </button>
        )}
        <p className="text-white text-[15px] font-bold truncate">{stream.host?.name}</p>
        <p className="text-[#B8B0C9] text-xs truncate">{stream.title}</p>
      </div>
    </div>
  );
}
